import styled from "styled-components";

import Colors from "@constants/Colors";

export const CurrentProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const CurrentProgressMainWrapper = styled.div``;

export const PercentageEventNameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 8px 0px 4px 0px;
`;

export const TitleValueWrapper = styled.div`
  display: flex;
  margin-top: 8px;
`;

export const CurrentProgressColorTag = styled.div<{
  backgroundColor: string;
}>`
  width: 12px;
  height: 12px;
  background: ${(props) => props.backgroundColor};
  margin: 5px 8px 0px 0px;
  box-shadow: ${Colors.Elevation_2};
  border-radius: 4px;
`;

export const PercentageWrapper = styled.div<{
  errorState?: boolean;
}>`
  font-family: Ringside Regular-Bold;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) =>
    props?.errorState ? Colors.primaryred : Colors.secondarypurple};
`;

export const EventTextWrapper = styled.div`
  font-family: Ringside Regular-Book;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  display: flex;
  align-items: center;
  text-align: center;

  color: #000000;
  text-align: center;
`;

export const TotalCardWrapper = styled.div`
  .customDivider {
    display: flex;
    justify-content: center;
  }
`;

export const TotalSalesSharedCardWrapper = styled.div`
  overflow-x: auto;
  display: flex;
`;

export const TotalSalesSharedCardMainWrapper = styled.div<{
  RemoveLeftPadding: boolean;
  RemoveRightPadding: boolean;
}>`
  float: left;
  padding: ${(props) =>
    props.RemoveLeftPadding
      ? "16px 8px 16px 0px"
      : `${props.RemoveRightPadding ? "16px 0px 16px 8px" : "16px 8px"}`};
`;

export const TotalSalesSharedCardSubWrapper = styled.div`
  height: 114px;
  min-width: 193px;
`;

export const ChildCardContentWrapper = styled.div`
  flex: 0 1 89px;
`;

export const ChildCardWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const ChildCardColumnWrapper = styled.div`
  margin-top: 8px;
  min-width: 62px;
`;
